import React from 'react';
import { ProSidebarProvider } from 'react-pro-sidebar';
import ErrorBoundary from './ErrorBoundary';
import ProjectRoutes from 'Routes';

function App() {
  return (
    
    <ErrorBoundary fa>
      <ProSidebarProvider>
        <ProjectRoutes />
      </ProSidebarProvider>
    </ErrorBoundary>
  );
}

export default App;
